import { computed } from 'vue-demi';
import { useMall } from './use-mall';
import { getCouponListBySPId } from '../../mch-coupon-list/business/coupon';
import { MerchantState, CouponInfo, CardType } from '../../../type';
import { AdInfo, CardInfo } from '../type';

const MAX_CARD_COUNT = 6;

/**
 * 处理商圈广告、展示券信息
 * @returns
 */
export function useCard() {
  const { currMallInfo, currAdInfo, currDpInfo } = useMall();
  const merchantInfo = computed(() => {
    const { id = '', name = '', logo = '' } = currMallInfo.value || {};
    return {
      spId: id,
      spLogo: logo,
      spName: name,
      totalValue: 0,
      state: MerchantState.Normal,
    };
  });

  const dpInfo = computed(() => {
    const { value } = currDpInfo;
    const result = { dpId: 0, themeId: '' };
    if (value) {
      result.dpId = +value.dpId;
      result.themeId = value.themeId;
    }
    return result;
  });

  const adCard = computed(() => {
    const { value: adInfo } = currAdInfo;
    const { dpId, themeId } = dpInfo.value;
    if (!adInfo) return null;
    const res: CardInfo & AdInfo = {
      dpId,
      id: themeId,
      type: CardType.Ad,
      imgUrl: adInfo.imgUrl,
      jumpUrl: adInfo.jumpUrl,
    };
    return res;
  });

  function formatCouponCard(couponInfo: CouponInfo, index: number): CardInfo & CouponInfo {
    const { dpId, themeId } = dpInfo.value;
    return {
      ...couponInfo,
      dpId,
      id: themeId,
      type: CardType.DisplayCoupon,
    };
  }

  /** 获取当前商圈下的卡(广告、展示券)信息 */
  async function getSpCardInfoList() {
    const { spId } = merchantInfo.value;
    const list: Array<CardInfo & (AdInfo | CouponInfo)> = [];
    const couponList = await getCouponListBySPId(spId, merchantInfo.value);

    // 广告信息加到第一位置
    if (adCard.value) list.push(adCard.value);

    couponList.forEach((coupon, index) => {
      list.push(formatCouponCard(coupon, index));
    });

    return list.slice(0, MAX_CARD_COUNT);
  }

  return {
    getSpCardInfoList,
  };
}
